import './TestimonialCard.css';
import { FaStar } from 'react-icons/fa';

function TestimonialCard({ testimonial }) {
  const rating = testimonial.rating || 5;

  return (
    <div className="testimonial-card">
      <div className="stars">
        {[...Array(rating)].map((_, i) => (
          <FaStar key={i} className="star" />
        ))}
      </div>
      <p className="message">"{testimonial.message}"</p>
      <div className="testimonial-author">
        {testimonial.image && <img src={testimonial.image} alt={testimonial.name} />}
        <div>
          <h4>{testimonial.name}</h4>
          {testimonial.title && <p>{testimonial.title}</p>}
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;
